import React, { useEffect, useState } from 'react';
import { ChatList } from 'react-chat-elements';
import user from '../../assets/images/user/users.png';
import { Button, Spinner, ListGroup, Form } from 'react-bootstrap';
import swal from 'sweetalert';
import { fetchIgConversations, instagramsendmessage } from '../../store/instagram/instagramThunk';
import { useDispatch, useSelector } from 'react-redux';

const UserList = ({ sharepost, hide }) => {
    const dispatch = useDispatch()
    const [chats, setChats] = useState([]);
    const [loader, setLoader] = useState(true);
    const [currentChatId, setCurrentChatId] = useState(null);
    const [selectedChats, setSelectedChats] = useState([]);
    const [senderId, setSenderId] = useState(null);
    const { conversations, loading, conversationDetails, error, message } = useSelector((state) => state.instagram);
    

    // const handleChatSelect = (item) => {
    //     setCurrentChatId(item.conversationId);
    //     setSenderId(item.id);
    // };

    useEffect(() => {
        // const fetchConversations = async () => {
        //     try {
        //         const conversations = await fetchIgConversations();
        //         console.log(conversations, "----------sr-------------")
        //         setChats(conversations);
        //     } catch (error) {
        //         console.error("Error fetching conversations:", error);
        //         swal("Error", "Failed to fetch conversations", "error");
        //     } finally {
        //         setLoader(false);
        //     }
        // };

        // fetchConversations();
    }, []);
    useEffect(() => {
        dispatch(fetchIgConversations());
    }, []);

    useEffect(() => {
        if (conversations) {
            setLoader(false);
            setChats(conversations);
        }
    }, [conversations]);

    const handleChatSelect = (item) => {
        setSelectedChats((prevSelectedChats) => {
            if (prevSelectedChats.includes(item.id)) {
                return prevSelectedChats.filter((chatId) => chatId !== item.id);
            } else {
                return [...prevSelectedChats, item.id];
            }
        });
    };
    console.log(selectedChats, "selectedChatsselectedChatsselectedChatsselectedChats")
    // const sendPost = async () => {
    //     // Check if senderId and sharepost are defined and valid
    //     if (!senderId) {
    //         swal("Warning", "Please select a chat first.", "warning");
    //         return;
    //     }
    //     if (!sharepost) {
    //         swal("Warning", "No post to share.", "warning");
    //         return;
    //     }

    //     console.log(senderId, "senderId");
    //     console.log(sharepost, "sharepost");



    //     const data = {
    //         recipient: { id: senderId },
    //         message: {
    //             attachment: {
    //                 type: "MEDIA_SHARE",
    //                 payload: {
    //                     id: sharepost?.id,
    //                     is_reusable: true,
    //                 },
    //             },
    //         },
    //     };

    //     try {
    //         // let response = await instagramsendmessage(data)
    //         // console.log("Response:", response.data);
    //         // swal("Success", "Post sent successfully.", "success");
    //         // handleShareModalClose()
    //     } catch (error) {
    //         console.error("Error sending post:", error.response ? error.response.data : error.message);
    //         swal("Error", "Failed to send post.", "error");

    //     }
    // };


    const dsaasdas = async () => {
        // Check if senderId and sharepost are defined and valid
        if (!selectedChats) {
            swal("Warning", "Please select a chat first.", "warning");
            return;
        }
        if (!sharepost) {
            swal("Warning", "No post to share.", "warning");
            return;
        }
        console.log(senderId, "senderId");
        console.log(sharepost, "sharepost");

        const data = {
            recipient: { id: senderId },
            message: {
                attachment: {
                    type: "asdasdasdsad",
                    payload: {
                        id: sharepost?.id,
                        is_reusable: true,
                    },
                },
            },
        };

        try {
            //   let response = await instagramsendmessage(data)
            await dispatch(instagramsendmessage(data));
      
        } catch (error) {
            console.error("Error sending post:", error.response ? error.response.data : error.message);
            swal("Error", "Failed to send post.", "error");
        }
    };

    const sendPost = async () => {

        for (const senderId of selectedChats) {
            let data;

            // Check if sharepost is defined
            if (!sharepost) {
                console.error("No post to share.");
                swal("Warning", "No post to share.", "warning");
                continue;  // Skip this iteration if no post is available
            }

            // Log the sharepost to ensure it's available
            console.log(sharepost, "sharepost");

            // Prepare the data with sharepost as attachment
            data = {
                recipient: { id: senderId },
                message: {
                    attachment: {
                        type: "MEDIA_SHARE",
                        payload: {
                            id: sharepost?.id,
                            is_reusable: true,
                        },
                    },
                },
            };

            try {
                // Show loading message
                // swal({
                //     title: "Sending...",
                //     text: "Your post is being sent, please wait.",
                //     icon: "info",
                //     buttons: false,
                //     closeOnClickOutside: false,
                //     closeOnEsc: false,
                // });

                // Send the post using the data object
                dispatch(instagramsendmessage(data));
                // swal("Success", "Post sent successfully.", "success");
                // hide()
            } catch (error) {
                console.error("Error sending post:", error.response ? error.response.data : error.message);
                swal("Error", "Failed to send post.", "error");
            }
        }
    }
    return (
        <div>
            {loader ? (
                <div className="text-center">
                    <Spinner animation="border" />
                    <p>Loading...</p>
                </div>
            ) : (
                <div >
                    {/* <div >
                        <ChatList
                            className="chat-list"
                            dataSource={chats?.map((chat) => ({
                                avatar: user,
                                alt: chat.first_name,
                                title: chat.participants
                                    ?.data[1]?.username || "Unknown User",
                                date: new Date(),
                                unread: 0,
                                conversationId: chat.conversationId,
                                id: chat.participants
                                    ?.data[1]?.id,
                            }))}
                            onClick={(item) => handleChatSelect(item)}
                        />
                        <Button className="w-100 mt-2" onClick={sendPost}>
                            Send
                        </Button>
                    </div> */}
                    <div>
                        <div className="mb-3">
                            <h5>Select Chats</h5>
                            <ListGroup>
                                {chats?.map((chat) => (
                                    <ListGroup.Item key={chat.participants?.data[1]?.id} className="d-flex align-items-center">
                                        <div className='d-flex justify-content-between w-100 align-items-center'>
                                            <div className='d-flex align-items-center'>

                                                <img src={user} alt="User Avatar" className="rounded-circle object-fit-cover" style={{ width: 40, height: 40 }} />
                                                <p className='ms-2 mb-0'>{chat.participants?.data[1]?.username || "Unknown User"} </p>
                                            </div>
                                            <Form.Check
                                                type="checkbox"
                                                checked={selectedChats.includes(chat.participants?.data[1]?.id)}
                                                onChange={() => handleChatSelect({
                                                    id: chat.participants?.data[1]?.id,
                                                    conversationId: chat.conversationId
                                                })}

                                                className="mr-2"
                                            />
                                        </div>

                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </div>
                        <Button className="w-100 mt-2" onClick={sendPost}>
                            Send
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserList;
